import { useEffect, useState } from 'react';

/**
 * Reaktiver Media-Query-Hook. SSR-/jsdom-sicher: ohne `matchMedia` → `false`.
 * Genutzt für responsive Verhaltensumschaltung (z. B. Karten als Mobile-Default).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(query);
    const handler = () => setMatches(list.matches);
    handler();
    list.addEventListener('change', handler);
    return () => list.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
